export default function emitDatePickerEvent(eventaction, options = {}) {
    // If edap does not exist, define array so overloaded push() method can raise event
    window.edap = window.edap || [];
    window.edap.push((edap) => {
        edap.trigger(eventaction, options);
    });
}
